import { styled } from "styled-components";
import { get } from "lodash/fp";
const TextImpl = styled("span")(
  ({ theme }) => ({
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    textOverflow: "ellipsis"
  }),
  ({ theme, $size }) => ({
    medium: {
      fontSize: theme.fontSize.md,
      lineHeight: theme.lineHeight.md
    },
    large: {
      fontSize: theme.fontSize.lg,
      lineHeight: theme.lineHeight.lg
    }
  })[$size],
  ({ $maxLines }) => typeof $maxLines === "number" && $maxLines > 0 ? {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": String($maxLines)
  } : void 0,
  ({ theme, $displayMode, $tone }) => get(
    $tone,
    $displayMode === "dark" ? {
      critical: {
        "--bungle-secondary-color": theme.color.red2,
        "--bungle-strong-color": theme.color.red4,
        "--bungle-text-color": theme.color.red3,
        color: theme.color.red3
      },
      neutral: {
        "--bungle-secondary-color": theme.color.white8,
        "--bungle-strong-color": theme.color.white10,
        "--bungle-text-color": theme.color.white9,
        color: theme.color.white9
      },
      positive: {
        "--bungle-secondary-color": theme.color.green2,
        "--bungle-strong-color": theme.color.green4,
        "--bungle-text-color": theme.color.green3,
        color: theme.color.green3
      },
      secondary: {
        "--bungle-secondary-color": theme.color.white8,
        "--bungle-strong-color": theme.color.white9,
        "--bungle-text-color": theme.color.white8,
        color: theme.color.white8
      }
    } : {
      critical: {
        "--bungle-secondary-color": theme.color.red5,
        "--bungle-strong-color": theme.color.red7,
        "--bungle-text-color": theme.color.red6,
        color: theme.color.red6
      },
      neutral: {
        "--bungle-secondary-color": theme.color.gray7,
        "--bungle-strong-color": theme.color.gray9,
        "--bungle-text-color": theme.color.gray8,
        color: theme.color.gray8
      },
      positive: {
        "--bungle-secondary-color": theme.color.green5,
        "--bungle-strong-color": theme.color.green7,
        "--bungle-text-color": theme.color.green6,
        color: theme.color.green6
      },
      secondary: {
        "--bungle-secondary-color": theme.color.gray7,
        "--bungle-strong-color": theme.color.gray8,
        "--bungle-text-color": theme.color.gray7,
        color: theme.color.gray7
      }
    }
  )
);
export {
  TextImpl
};
